import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const MediaMarqueeBase = styled.div`
  background: ${theme.colors.darkBlues[5]};
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: ${theme.sliceSpacing};
`;

export const PrimaryWrapper = styled.div``;

export const PrimaryCopy = styled.div`
  padding-right: ${theme.spacing[8]};
  padding-bottom: ${theme.spacing[8]};
`;

export const Headline = styled.h2``;

export const Description = styled.div`
  font-size: ${theme.fontSizes[2]};
`;

export const VideoWrapper = styled.div`
  max-width: 792px;
`;

export const VideoEmbed = styled.div`
  width: 100%;
  height: auto;
  aspect-ratio: 16/9;
`;

export const Features = styled.div``;

export const Feature = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: ${theme.spacing[2]};
  align-content: flex-start;
`;

export const FeatureImage = styled.img`
  max-width: 78px;
  max-height: 78px;
  object-fit: contain;

  ${theme.smallerThan.sm} {
    margin-left: auto;
    margin-right: auto;
  }
`;

export const FeatureTitle = styled.div`
  font-size: ${theme.fontSizes[3]};
  font-weight: ${theme.fontWeights.semibold};
`;

export const FeatureDescription = styled.div`
  color: ${theme.colors.darkBlues[75]};
  font-size: ${theme.fontSizes[2]};
`;

export const Footer = styled.div`
  max-width: 588px;
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.darkBlues[90]};

  /* Default link color doesn't pass accessibility contrast specs with this background */
  /* https://web.dev/color-contrast/?utm_source=lighthouse&utm_medium=devtools#how-to-ensure-text-has-sufficient-color-contrast */
  a {
    color: ${theme.colors.blues[125]};
  }
`;
